import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ui.css';

const TYPE_LABELS = {
  REVIEWER_REQUEST_CHANGES: 'Reviewer requested changes for the Proposal',
  REVIEWER_ASSIGNED: 'Assigned as reviewer',
  REVIEWER_UNASSIGNED: 'Unassigned as reviewer',
  SECRETARY_SENT_RESUBMIT_EMAIL: 'Resubmission requested',
  RESEARCHER_RESUBMITTED: 'Researcher resubmitted',
  PROPOSAL_APPROVED: 'Proposal approved',
  PROPOSAL_REJECTED: 'Proposal rejected',
  MEETING_SCHEDULED: 'Meeting scheduled',
  MEETING_DECISION_RECORDED: 'Meeting decision recorded',
  NEW_COMMENT: 'New comment on proposal',
  SYSTEM_EXCEPTION: 'System alert',
  CHILD_CREATED: 'Child request created',
  CHILD_STATUS_CHANGED: 'Child request status updated',
};

function humanizeType(s) {
  if (!s) return '';
  if (TYPE_LABELS[s]) return TYPE_LABELS[s];
  return String(s)
    .toLowerCase()
    .split(/[_\s]+/)
    .map(w => (w ? w[0].toUpperCase() + w.slice(1) : w))
    .join(' ');
}

export default function Inbox() {
  const roleId = parseInt(localStorage.getItem('role_id'), 10) || 1;
  const [rows, setRows] = useState([]);
  const [tab, setTab] = useState('UNREAD');
  const navigate = useNavigate();

  async function load(unreadOnly = true) {
    const token = localStorage.getItem('token');
    const res = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/notifications?unreadOnly=${unreadOnly}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const data = await res.json();
    setRows(Array.isArray(data) ? data : []);
  }

  async function markRead(id) {
    const token = localStorage.getItem('token');
    await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/notifications/${id}/read`,
      { method: 'POST', headers: { Authorization: `Bearer ${token}` } }
    );
  }

  useEffect(() => { load(true); }, []);

  const openRow = async (r) => {
    await markRead(r.id);
    if (r.ref_kind === 'CHILD') {
      navigate(`/children/${r.ref_id}`);
    } else if (r.ref_kind === 'EXCEPTION') {
      navigate('/exceptions');
    } else if (r.ref_kind === 'PROPOSAL') {
      if (r.type === 'REVIEWER_REQUEST_CHANGES') {
        navigate(`/proposal/${r.ref_id}?secChange=1`);
      } else {
        navigate(`/proposal/${r.ref_id}`);
      }
    } else {
      navigate('/dashboard');
    }
  };

  const switchTab = (newTab) => {
    setTab(newTab);
    load(newTab === 'UNREAD');
  };

  return (
    <div className="proposal-details-container">
      <div className="card">
        <div className="details-header header-row">
          <h2>Notifications</h2>
          <span className="status-pill-header">
            {tab === 'UNREAD' ? 'Unread' : 'All'}
          </span>
        </div>

        <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
          <button
            className={`btn tab ${tab === 'UNREAD' ? 'active' : ''}`}
            onClick={() => switchTab('UNREAD')}
          >
            Unread
          </button>
          <button
            className={`btn tab ${tab === 'ALL' ? 'active' : ''}`}
            onClick={() => switchTab('ALL')}
          >
            All
          </button>
        </div>
      </div>

      <div className="card" style={{ marginTop: 12 }}>
        <table className="table-std">
          <thead>
            <tr>
              <th>Type</th>
              <th>Created</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>{humanizeType(r.type)}</td>
                <td>{new Date(r.created_at).toLocaleString()}</td>
                <td>
                  <button className="btn primary" onClick={() => openRow(r)}>
                    Open
                  </button>
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan={3} className="empty-state">No items</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
